<mat-card class="card-review" *ngIf="isMilio(item.reviewPeriod.reviewType)">
    <mat-card-content class="responsive-size">
        <div class="field-name">
            <div class="card-category">{{ getCategoryName(item) }}</div>
            <div class="card-title">{{ getItemName(item) }}</div>
        </div>
        <div class="field-details">
            <div class="field-block" *ngIf="!item.isRpeClosed && getRpeDeadline()">
                <div class="field-block-title">{{ 'ASSESSMENTS.DEADLINE' | translate }}</div>
                <div class="field-block-value" [ngClass]="{'date-expired': isDateExpired(item.endDate)}">
                    {{ getRpeDeadline() | datePlain}}
                </div>
            </div>
            <div class="field-block" *ngIf="item.isRpeClosed">
                <div class="field-block-title">{{ 'ASSESSMENTS.COMPLETED' | translate }}</div>
                <div class="field-block-value">
                    {{ getReviewDate() | localizedDate }}
                </div>
            </div>
            <div class="field-block">
                <div class="field-block-title">{{ 'ASSESSMENTS.STATUS' | translate }}</div>
                <div class="field-block-value">{{ item | assessmentStatus }}</div>
            </div>
        </div>
        <div class="card-actions">
            <button mat-flat-button class="review-button button-bg-alt2" *ngIf="isRpOpen(item.reviewPeriod) && !isRpeFinished(item.reviewPeriodEmployee)" (click)="loadAssessmentPage()">{{ 'ASSESSMENTS.FILL_OUT' | translate }}</button>
        </div>
    </mat-card-content>
</mat-card>

<mat-expansion-panel class="expansion-panel-review" hideToggle *ngIf="isSziluett(item.reviewPeriod.reviewType) || isPanorama(item.reviewPeriod.reviewType)" (opened)="changeExpand()" (closed)="changeExpand()">
    <mat-expansion-panel-header>
        <div class="field-name">
            <div class="card-category">{{ getCategoryName(item) }}</div>
            <div class="card-title">{{ getItemName(item) }}</div>
        </div>
        <div class="field-details">
            <div class="field-block" *ngIf="isProgress">
                <mat-progress-spinner
                   diameter="28"
                   color="primary"
                   mode="indeterminate">
               </mat-progress-spinner>
            </div>
            <div class="field-block">
                <div class="field-block-title">{{ item.isRpClosed && !isSziluett(item.reviewPeriod.reviewType) ? ('ASSESSMENTS.CLOSED' | translate) : '' }}</div>
                <div class="field-block-value" [ngClass]="{'date-expired': isDateExpired(item.endDate)}">
                    <span *ngIf="isPanorama(item.reviewPeriod.reviewType)">{{ (item.isRpClosed ? item.reviewPeriod.endDate : null) | datePlain }}</span>
                    <span *ngIf="!isPanorama(item.reviewPeriod.reviewType)">{{ (item.isRpeClosed ? item.closedOn : null) | localizedDate }}</span>
                </div>
            </div>
            <div class="field-block" *ngIf="!isSziluett(item.reviewPeriod.reviewType) || isRpClosed(item.reviewPeriod)">
                <div class="field-block-title">{{ 'ASSESSMENTS.STATUS' | translate }}</div>
                <div class="field-block-value">{{ item | assessmentStatus }}</div>
            </div>
        </div>
        <div class="card-actions">
            <button mat-flat-button color="primary" class="review-button bt-long-text" [ngClass]="{'loading': isProgress}">
                <mat-icon *ngIf="!expanded" >keyboard_arrow_down</mat-icon>
                <mat-icon *ngIf="expanded">keyboard_arrow_up</mat-icon>
                {{ 'ASSESSMENTS.DETAILS' | translate }}
            </button>
        </div>
    </mat-expansion-panel-header>
    <app-assessment-list-item-details [reviewPeriod]="item.reviewPeriod" [employee]="employee" [closedGroup]="closedGroup" *ngIf="loaded" (onLoading)="detailsLoading(true)" (onLoaded)="detailsLoading(false)"></app-assessment-list-item-details>
</mat-expansion-panel>
